import { useKeyboardControls } from "@react-three/drei";
import useGame from "./stores/useGame.js";
import { useEffect, useRef, useState } from "react";
import { addEffect } from "@react-three/fiber";
import Modal from "./Modal.jsx";

export default function Interface() {
  const time = useRef();
  const restart = useGame((state) => state.restart);
  const booksRemaining = useGame((state) => state.booksRemaining);

  const [showModal, setShowModal] = useState(false);

  const forward = useKeyboardControls((state) => state.forward);
  const backward = useKeyboardControls((state) => state.backward);
  const left = useKeyboardControls((state) => state.left);
  const right = useKeyboardControls((state) => state.right);
  const jump = useKeyboardControls((state) => state.jump);

  useEffect(() => {
    const unsubscribeEffect = addEffect(() => {
      const state = useGame.getState();
      let remainingTime = state.timeLeft;

      const minutes = Math.floor(remainingTime / 60);
      const seconds = remainingTime % 60;
      const formattedTime = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;

      if (time.current) {
        time.current.textContent = formattedTime;
      }
    });

    return () => {
      unsubscribeEffect();
    };
  }, []);

  useEffect(() => {
    if (booksRemaining === 0) {
      setShowModal(true);
    }
  }, [booksRemaining]);

  const handleModalClose = () => {
    setShowModal(false);
    restart();
  };

  return (
    <div className="interface">
      <div ref={time} className="time">5:00</div>
      <div className="restart" onClick={restart}>Restart</div>
      <div className="books">
        <div className="titleBooks">Books Remaining:</div>
        <div className="numberBooks">{booksRemaining}</div>
      </div>
      <div className="boxing">
        <div className="controls">
          <div className="raw">
            <div className={`key ${forward ? 'active' : ''}`}></div>
          </div>
          <div className="raw">
            <div className={`key ${left ? 'active' : ''}`}></div>
            <div className={`key ${backward ? 'active' : ''}`}></div>
            <div className={`key ${right ? 'active' : ''}`}></div>
          </div>
          <div className="raw">
            <div className={`key large ${jump ? 'active' : ''}`}></div>
          </div>
        </div>
      </div>
      <Modal show={showModal} onClose={handleModalClose} />
    </div>
  );
}
